import InboxLister from './inbox-lister-mapping';

export default InboxLister;
